import React, { Fragment, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import emailSendImages from '../../images/undraw_Share_link_re_54rx.png'
import { passwordResetRequestByEmail, clearErrorAction } from '../../redux/actions/userAction'
import Loader from '../../layout/loader';
import MetaTag from '../../layout/MetaTag';
import './forgotPassword.css'

function ForgotPasswordEmail() {

    const dispatch = useDispatch();
    const { error, loading, message } = useSelector((state) => state.passwordResetByEmail)


    const [email, setEmail] = useState('');


    useEffect(() => {
        if (error) {
            swal({
                title: "Validation Error",
                text: error,
                icon: "error",
            })
            dispatch(clearErrorAction())
        }
        if (message) {
            swal({
                title: "Success",
                text: message,
                icon: "success",
            })
        }

    }, [dispatch, error, message])


    const resetPasswordHandler = (e) => {
        e.preventDefault();
        if (!email) {
            return swal({
                title: "Validation Error..!!",
                text: "Please fill email..!",
                icon: "info",
            })

        }

        dispatch(passwordResetRequestByEmail(email))

    }

    return (
        <Fragment>
            <MetaTag title={'lost your password ? please enter your email address, to Update your Password.'} />
            {loading ? <Loader /> : (<Fragment>
                <div className="forgot-password-div-main">
                    <section className="forgot-password-panel">
                        <div className="forgot-password-image-div">
                            <span>Account recovery</span>
                            <h1>Get back to your sneaker account</h1>
                            <p>We will send a secure reset link to your registered email so you can create a fresh password.</p>
                            <img src={emailSendImages} alt="Secure password reset" />
                            <div className="forgot-password-benefits">
                                <span>Secure link</span>
                                <span>Email only</span>
                                <span>Fast access</span>
                            </div>
                        </div>

                        <div className="forgot-password-card">
                            <div className="forgot-password-heading">
                                <span>Forgot password</span>
                                <h2>Reset your password</h2>
                                <p>
                                    Enter the email linked with your IM Online Shop account. The reset link will arrive in your inbox.
                                </p>
                            </div>

                            <div className="form-div-for-email">
                                <form onSubmit={resetPasswordHandler} method='POST'>
                                    <label htmlFor="forgot-password-email">Email address</label>
                                    <input
                                        id="forgot-password-email"
                                        type="email"
                                        placeholder='you@example.com'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <button className='reset-password-button'>Send Reset Link</button>
                                </form>
                            </div>

                            <div className="forgot-password-footer">
                                <Link to="/Login">Back to login</Link>
                                <Link to="/Signin">Create account</Link>
                            </div>
                        </div>
                    </section>
                </div>
            </Fragment>)}
        </Fragment>
    )
}

export default ForgotPasswordEmail
